import { type DefaultConfigOptions, createInput } from '@formkit/vue'
import { createLocalStoragePlugin } from '@formkit/addons'
import { generateClasses } from '@formkit/themes'
import formkitTheme, { requiredSuffixPlugin } from './formkit/theme'
import Select from './formkit/Select.vue'
import Disclosure from './formkit/Disclosure.vue'
import Repeater from './formkit/Repeater.vue'
import RepeaterItem from './formkit/RepeaterItem.vue'
import AssistantText from './formkit/AssistantText.vue'
import Toggle from './formkit/Toggle.vue'
import Channels from './formkit/Channels.vue'
import RichEditor from './formkit/RichEditor.vue'
import Number from './formkit/Number.vue'
import PickList from './formkit/PickList.vue'
import FilterOptions from './formkit/FilterOptions.vue'
import ComputedText from './formkit/ComputedText.vue'
import Upload from './formkit/Upload.vue'
import VideoUpload from './formkit/VideoUpload.vue'
import ImageHotspotTagger from './formkit/ImageHotspotTagger.vue'
import InspirationImagePicker from './formkit/InspirationImagePicker.vue'
import Date from './formkit/Date.vue'
import Draggable from './formkit/Draggable.vue'
import DraggableDisclosure from './formkit/DraggableDisclosure.vue'
import file from './formkit/customRules/file'
import TagsSelectInputVue from './formkit/TagsSelectInput.vue'
import ProductCategorySelect from './formkit/ProductCategorySelect.vue'
import FormkitAdapter from './formkit/Adapter.vue'
import AiFillSlot from './formkit/AiFillSlot.vue'
import AiFillField from './formkit/AiFillField.vue'

const props = [
  'mode',
  'options',
  'initialOptions',
  'placeholder',
  'canClear',
  'canDeselect',
  'searchable',
  'trackBy',
  'filterResults',
  'resolveOnLoad',
  'watcher',
  'nameValue',
  'delay',
  'size',
  'groups',
  'object',
  'watch',
  'where',
  'keepValuesOnWatch',
  'ignoreRouteChannel',
  'view',
]

const config: DefaultConfigOptions = {
  plugins: [
    requiredSuffixPlugin,
    createLocalStoragePlugin({
      // plugin defaults:
      prefix: 'formkit',
      key: undefined,
      control: undefined,
      maxAge: 3600000, // 1 hour
      debounce: 200,
      beforeSave: undefined,
      beforeLoad: undefined,
    }),
  ],
  config: {
    classes: generateClasses(formkitTheme),
  },
  inputs: {
    toggle: {
      type: 'input',
      component: Toggle,
    },
    disclosure: {
      type: 'group',
      component: Disclosure,
    },
    draggableDisclosure: {
      type: 'input',
      component: DraggableDisclosure,
      // props: ['nodeComponent', 'innerSchema', 'label']
    },
    channels: {
      type: 'input',
      component: Channels,
      props: ['channels'],
    },
    repeater: {
      type: 'list',
      component: Repeater,
    },
    draggable: {
      type: 'list',
      component: Draggable,
    },
    repeaterItem: {
      type: 'group',
      component: RepeaterItem,
    },
    assistantText: {
      type: 'input',
      component: AssistantText,
    },
    productCategorySelect: {
      type: 'input',
      component: ProductCategorySelect,
      props: ['channelId'],
    },
    number: createInput(Number, {
      props: ['mode'],
    }),
    multiselect: createInput(Select, {
      props,
    }),
    adapter: createInput(FormkitAdapter, {
      props: [
        ...props,
        'component',
      ]
    }),
    upload: createInput(Upload, {
      props: ['accept', 'type', 'filename'],
    }),
    videoUpload: createInput(VideoUpload, {
      props: ['videoType'],
    }),
    computedText: createInput(ComputedText, {
      props: ['setValue'],
    }),
    pickImages: {
      type: 'input',
      component: PickList,
    },
    wysiwyg: createInput(RichEditor),
    filterOptions: {
      type: 'input',
      component: FilterOptions,
    },
    tagsSelect: createInput(TagsSelectInputVue, {
      props: ['options'],
    }),
    date: createInput(Date, {
      props: ['mode', 'showTime', 'view'],
    }),
    imageHotspotTagger: createInput(ImageHotspotTagger, {
      props: ['imageUrl', 'imageField', 'schema'],
    }),
    inspirationImagePicker: createInput(InspirationImagePicker),
    aiFillSlot: {
      type: 'input',
      component: AiFillSlot,
    },
    aiFillField: {
      type: 'input',
      component: AiFillField,
    },
  },
  rules: {
    file,
  },
}

export default config
